import React, { useEffect } from "react";
import { Modal, Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import {
  setDownloadInvoiceModalOpen,
} from "../../../../redux/reducers/JobExport";
import {
  setDownloadOptionsSelectedDocumentIds,
  setDocuments,
} from "../../../../redux/reducers/InvoiceManager";
import CsvInvoiceOptions from "./DownloadOptions/CsvInvoiceOptions";
import DocumentsInvoiceDropdown from "./DownloadOptions/DocumentsInvoiceDropdown";
import ExportTypeInvoiceModalDropdown from "./DownloadOptions/ExportTypeInvoiceModalDropdown";
import InvoiceIifOptions from "./DownloadOptions/InvoiceIifOptions";

export const DownloadInvoiceModal = () => {
  const dispatch = useDispatch();
  const { downloadInvoiceModalOpen } = useSelector(
    (state: ReduxState) => state.JobExport
  );
  const { selectedExportTypeModal } = useSelector(
    (state: ReduxState) => state.DownloadInvoiceOptions
  );
  const { documents, downloadOptions } = useSelector(
    (state: ReduxState) => state.InvoiceManager
  );
  const jobDocuments = useSelector(
    (state: ReduxState) => state.JobDocument.data
  );

  useEffect(() => {
    if (!downloadInvoiceModalOpen) return;

    // If InvoiceManager.documents is empty but JobDocument.data has invoice
    // docs for this project, mirror them into InvoiceManager so the
    // Documents dropdown can render them.
    if ((documents || []).length === 0 && (jobDocuments || []).length > 0) {
      const mirrored = (jobDocuments || []).map((d: any) => ({
        id: String(d.documentId ?? d.id),
        originalname:
          d.originalname ?? d.fileName ?? d.name ?? String(d.documentId ?? d.id),
        hasNoTransactions: false,
        hasPartialExtraction: false,
      })) as any;
      dispatch(setDocuments(mirrored));
    }

    if ((downloadOptions.selectedDocumentIds || []).length > 0) return;
    const fromInvoiceManager = (documents || []).map(d => d.id.toString());
    const fromJobDocument = (jobDocuments || []).map(d =>
      String((d as any).documentId ?? (d as any).id)
    );
    const allIds =
      fromInvoiceManager.length > 0 ? fromInvoiceManager : fromJobDocument;
    if (allIds.length > 0) {
      dispatch(setDownloadOptionsSelectedDocumentIds(allIds));
    }
  }, [
    downloadInvoiceModalOpen,
    documents,
    jobDocuments,
    downloadOptions.selectedDocumentIds,
    dispatch,
  ]);

  const toggle = () => dispatch(setDownloadInvoiceModalOpen(!downloadInvoiceModalOpen));

  return (
    <>
      <Modal size="lg" show={downloadInvoiceModalOpen} onHide={toggle}>
        <Modal.Header closeButton>
          <Modal.Title>Download Invoice Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className="p-0">
            <Row className="my-2">
              <Col md="6">
                <div className="font-weight-bold">Documents</div>
                <DocumentsInvoiceDropdown />
              </Col>
              <Col md="6">
                <div className="font-weight-bold">Output Format</div>
                <ExportTypeInvoiceModalDropdown />
              </Col>
            </Row>
            <div className="my-2">
              {selectedExportTypeModal === "iif" ? (
                <InvoiceIifOptions source="modal" />
              ) : (
                <CsvInvoiceOptions cta={"Download"} />
              )}
            </div>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};
